document.addEventListener("DOMContentLoaded", function () {

    var  multiColumnSwiper = new Swiper('.multi-column--looks-swiper', {
      loop: true,
      effect: "fade",
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
    //checking if there is more than one section
    if (multiColumnSwiper && multiColumnSwiper.length > 0) {
      multiColumnSwiper = multiColumnSwiper[0];
      const swiperWrappers = document.querySelectorAll('.swiper-wrapper');
      for (let i = 1; i < swiperWrappers.length; i++) {
        swiperWrappers[i].childNodes.forEach((childNode) => {
          if (childNode.nodeType === 1) { 
            // Check if it's an element node
            const slideContent = childNode.cloneNode(true);
            multiColumnSwiper.appendSlide(slideContent);
          }
        });
      }
    }
    const multiColumnModal = document.querySelector('[data-multi-column-modal]');
    const multiColumnModalContent = multiColumnModal?.querySelector('[data-multi-column-content]');
    var multiColumnItems = document.querySelectorAll('[data-multi-column]');
    const multiColumnCloseBtn = multiColumnModal?.querySelector('[data-multi-column-close]');

    if (multiColumnItems.length) {
      multiColumnItems?.forEach((item, index) => {
        item.addEventListener("click", e => {
          e.preventDefault();
          multiColumnModalOpener(index);
        });
      })
    }
    
    if(multiColumnCloseBtn) {
      multiColumnCloseBtn.addEventListener("click", e => {
        e.preventDefault();
        multiColumnClose();
      });
    }
    
    multiColumnModal?.addEventListener("click", e => {
      multiColumnClose();
    });
    
    multiColumnModalContent?.addEventListener("click", e => {
      e.stopPropagation();
    });
    
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') { 
        const isNotCombinedKey = !(e.ctrlKey || e.altKey || e.shiftKey);
        if (isNotCombinedKey) { 
          multiColumnClose();
        }
      }
    });
    
    function multiColumnClose() {
      if(multiColumnModal) {
        multiColumnModal.classList.remove("is-visible");
        document.body.style.overflowY = "auto";
        multiColumnModal.scrollTop = 0;
      }
    }
    
    function multiColumnModalOpener(index) {
      if(multiColumnModal) {
        multiColumnSwiper?.slideToLoop(index, 0, false);
        multiColumnModal.classList.add("is-visible");
        multiColumnModal.scrollTop = 0;
        document.body.style.overflowY = "hidden";
        multiColumnAnimations();
      } 
    }
    
    function multiColumnAnimations() {
      const multiColumnModalContent = multiColumnModal?.querySelector('[data-multi-column-content]');
        if (multiColumnModalContent) {
          multiColumnModalContent.style.transitionDelay = `100ms`;
        }
    }


 });